import React from "react";
import {
  Box,
  Chip,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { createEmptyRecipeRow } from "../../@shared/game/craftRecipeUtils";

export default function InfinityRecipeEditor({
  rows = [],
  onChange,
  cardOptions = [],
  disabled = false,
}) {
  const safeRows = Array.isArray(rows) ? rows : [];

  const updateRow = (index, key, value) => {
    const nextRows = [...safeRows];
    nextRows[index] = {
      ...nextRows[index],
      [key]: value,
    };
    onChange?.(nextRows);
  };

  const addRow = () => {
    onChange?.([...safeRows, createEmptyRecipeRow()]);
  };

  const removeRow = (index) => {
    onChange?.(safeRows.filter((_, rowIndex) => rowIndex !== index));
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 2,
        }}
      >
        <Typography sx={{ fontWeight: 700 }}>Craft Recipe</Typography>
        <IconButton onClick={addRow} disabled={disabled} size="small">
          <AddCircleOutlineIcon />
        </IconButton>
      </Box>

      {!safeRows.length && (
        <Typography variant="body2" sx={{ opacity: 0.72 }}>
          Add one or more material cards for this finite recipe.
        </Typography>
      )}

      {safeRows.map((row, index) => (
        <Grid container spacing={1} key={`recipe-row-${index}`}>
          <Grid item xs={12} md={8}>
            <FormControl fullWidth size="small" disabled={disabled}>
              <InputLabel id={`recipe-material-${index}`}>Material Card</InputLabel>
              <Select
                labelId={`recipe-material-${index}`}
                label="Material Card"
                value={row?.name || ""}
                onChange={(event) =>
                  updateRow(index, "name", event.target.value)
                }
                renderValue={(selected) =>
                  selected ? (
                    <Chip size="small" label={selected} />
                  ) : (
                    <Typography sx={{ opacity: 0.6 }}>
                      Select material
                    </Typography>
                  )
                }
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                {cardOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={8} md={3}>
            <TextField
              fullWidth
              size="small"
              type="number"
              label="Amount"
              value={row?.amount || ""}
              disabled={disabled}
              onChange={(event) =>
                updateRow(index, "amount", event.target.value)
              }
              inputProps={{ min: 1, step: 1 }}
            />
          </Grid>

          <Grid
            item
            xs={4}
            md={1}
            sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
          >
            <IconButton
              onClick={() => removeRow(index)}
              disabled={disabled}
              size="small"
              color="error"
            >
              <RemoveCircleOutlineIcon />
            </IconButton>
          </Grid>
        </Grid>
      ))}
    </Box>
  );
}
